export default __webpack_public_path__ + "static/media/GoodMannersWithYourFriends_07.c8133dc9.png";